import { apiStatementDeliveryPreferences } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

export const typePrefix = 'statement-delivery-preferences';

const config = [
  { actionType: 'getAll', apiPath: apiStatementDeliveryPreferences, method: get },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiStatementDeliveryPreferences}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
